import React from 'react';
import { GiPadlock } from 'react-icons/gi';

import styles from './Lock.module.scss';

const Lock = ({ label }) => {
  return (
    <div className={styles.lock}>
      <div className={styles.badge}>
        <GiPadlock />
      </div>

      {label ? (
        Array.isArray(label) ? (
          label.map((it, idx) => (
            <span key={idx} className={styles.label}>
              {it}
            </span>
          ))
        ) : (
          <span className={styles.label}>{label}</span>
        )
      ) : null}
    </div>
  );
};

export default Lock;
